<div class="list-group" [hidden]="!searchResultsVisible" style="display: block; margin-bottom: 0px">
    <div *ngFor="let provider of hsSearchService.providers | keyvalue ">
        <a class="list-group-item active" [hidden]="!(provider.value.results.length > 0)">Provider:
            {{provider.value.name}}</a>
        <a *ngFor="let result of provider.value.results | limitTo: 10" class="list-group-item hsl-search-result"
            [ngClass]="{'active': result.highlighted}" (click)="zoomTo(result)"
            (mouseover)="highlightResult(result, true)" (mouseleave)="highlightResult(result, false)"
            [attr.title]="result.DisplayDescription">{{result.name || result.DisplayTitle}}<small
                style="color: rgb(148, 143, 143)"><br>{{result.fcodeName}}</small></a>
    </div>
</div>